export async function rotateImageUrlToBlob(
    url: string,
    turns: number,
    preferredType?: string
): Promise<Blob> {
    const t = ((turns % 4) + 4) % 4;
    if (!t) {
        const res = await fetch(url);
        return res.blob();
    }
    const img = await loadImage(url);
    const swap = t % 2 === 1;
    const canvas = document.createElement('canvas');
    canvas.width = swap ? img.naturalHeight : img.naturalWidth;
    canvas.height = swap ? img.naturalWidth : img.naturalHeight;
    const ctx = canvas.getContext('2d');
    if (!ctx) {
        throw new Error('2d context unavailable');
    }
    ctx.translate(canvas.width / 2, canvas.height / 2);
    ctx.rotate((t * Math.PI) / 2);
    ctx.drawImage(img, -img.naturalWidth / 2, -img.naturalHeight / 2);
    const type =
        preferredType && preferredType.indexOf('png') >= 0
            ? 'image/png'
            : 'image/jpeg';
    const quality = type === 'image/jpeg' ? 0.92 : undefined;
    return new Promise((resolve, reject) => {
        canvas.toBlob(
            b => {
                if (!b) {
                    reject(new Error('rotate toBlob failed'));
                    return;
                }
                resolve(b);
            },
            type,
            quality
        );
    });
}

function loadImage(url: string): Promise<HTMLImageElement> {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => resolve(img);
        img.onerror = () => reject(new Error('image load failed'));
        img.src = url;
    });
}

export function filenameWithRotation(name: string, turns: number): string {
    const t = ((turns % 4) + 4) % 4;
    if (!t) {
        return name;
    }
    const deg = t * 90;
    const cleaned = name.replace(/-rot(90|180|270)(?=\.|$)/i, '');
    const dot = cleaned.lastIndexOf('.');
    if (dot <= 0) {
        return `${cleaned}-rot${deg}`;
    }
    return `${cleaned.slice(0, dot)}-rot${deg}${cleaned.slice(dot)}`;
}
